import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import FullPageLoader from "components/FullPageLoader/fullpageloader";
import NoRecordFound from "components/NoRecordFound/NoRecordFound";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Table,
} from "reactstrap";
import { getMethod } from "services/httpServices";
import { getUserId } from "services/httpServices";
import { btnCss, iconCss } from "../../appConfig";
import ReactPaginate from "react-paginate";
import moment from "moment";

function RefundStatusBadge({ status }) {
  const color =
    status === "Pending"
      ? "#ffa800"
      : status === "Approved"
      ? "#008000"
      : status === "Rejected"
      ? "#dc3545"
      : "#6c757d";
  return (
    <span
      style={{
        background: color,
        color: "#fff",
        borderRadius: 8,
        padding: "2px 10px",
        fontSize: 12,
        fontWeight: "bold",
        textTransform: "capitalize",
        minWidth: 60,
        display: "inline-block",
        textAlign: "center",
      }}
    >
      {status}
    </span>
  );
}

function RefundTimeline({ refund }) {
  const getTimelineSteps = (refund) => {
    const steps = [];
    // Requested step: always use createdDate
    steps.push({
      status: "Requested",
      label: "Requested",
      subLabel: refund.createdDate
        ? moment(refund.createdDate).format("DD/MM/YYYY HH:mm:ss")
        : "-",
    });
    // Under Review (if not pending): use updatedDate if available, else createdDate
    if (refund.refundStatus !== "Pending") {
      steps.push({
        status: "Under Review",
        label: "Under Review",
        subLabel: refund.updatedDate
          ? moment(refund.updatedDate).format("DD/MM/YYYY HH:mm:ss")
          : refund.createdDate
          ? moment(refund.createdDate).format("DD/MM/YYYY HH:mm:ss")
          : "-",
      });
    }
    // Approved/Rejected: always use updatedDate
    if (refund.refundStatus === "Approved") {
      steps.push({
        status: "Approved",
        label: "Approved",
        subLabel: refund.updatedDate
          ? moment(refund.updatedDate).format("DD/MM/YYYY HH:mm:ss")
          : "-",
      });
    } else if (refund.refundStatus === "Rejected") {
      steps.push({
        status: "Rejected",
        label: "Rejected",
        subLabel: refund.updatedDate
          ? moment(refund.updatedDate).format("DD/MM/YYYY HH:mm:ss")
          : "-",
      });
    } else {
      // Pending: use updatedDate if available, else createdDate
      steps.push({
        status: "Pending",
        label: "Pending",
        subLabel: refund.updatedDate
          ? moment(refund.updatedDate).format("DD/MM/YYYY HH:mm:ss")
          : refund.createdDate
          ? moment(refund.createdDate).format("DD/MM/YYYY HH:mm:ss")
          : "-",
      });
    }
    return steps;
  };

  const timelineSteps = getTimelineSteps(refund);

  return (
    <div className="refund-timeline-bar-modern">
      <div className="timeline-bar-modern">
        <div className="timeline-bar-modern-line" />
        {timelineSteps.map((step, idx) => (
          <div className="timeline-bar-step-modern" key={idx}>
            <div className="timeline-bar-halo-modern">
              <div className="timeline-bar-circle-modern" />
            </div>
          </div>
        ))}
      </div>
      <div className="timeline-bar-labels-modern">
        {timelineSteps.map((step, idx) => (
          <div
            className="timeline-bar-label-group-modern"
            key={idx}
            style={{ width: `${100 / timelineSteps.length}%` }}
          >
            <div className="timeline-bar-label-modern">{step.label}</div>
            <div className="timeline-bar-sublabel-modern">{step.subLabel}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function RefundList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  };

  function fetchData() {
    setLoading(true);
    getMethod(
      "/api/Transactions/Refund/HistoryByMerchant?merchantId=" + getUserId()
    )
      .then((res) => {
        if (res.data?.result?.length) {
          setData(res.data.result);
        } else {
          setData([]);
        }
      })
      .catch(console.log)
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  let filteredData = data;
  if (searchText) {
    filteredData = filteredData.filter(
      (item) =>
        String(item?.customerName)
          .toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        String(item?.customerPhoneNumber)
          .toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        String(item?.transactionId)
          .toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        String(item?.reasonForRefund)
          .toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        String(item?.refundStatus)
          .toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        String(item?.description)
          .toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        String(item?.id)
          .toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        String(item?.amount)
          .toLowerCase()
          .includes(searchText.trim().toLowerCase())
    );
  }

  return (
    <div>
      <style>
        {`
          .refund-timeline-bar-modern {
            width: 100%;
            margin: 0 auto;
            max-width: 100%;
          }
          .timeline-bar-modern {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            width: 100%;
            height: 32px;
            margin: 0 auto;
            z-index: 1;
          }
          .timeline-bar-modern-line {
            position: absolute;
            top: 50%;
            left: 10px;
            right: 10px;
            height: 10px;
            background: #2d5fa7;
            border-radius: 5px;
            z-index: 0;
            transform: translateY(-50%);
          }
          .timeline-bar-step-modern {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 2;
          }
          .timeline-bar-halo-modern {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(45, 95, 167, 0.10);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 2;
          }
          .timeline-bar-circle-modern {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: #fff;
            border: 4px solid #2d5fa7;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 3;
          }
          .timeline-bar-circle-modern::after {
            content: '';
            display: block;
            width: 12px;
            height: 12px;
            background: #ff9800;
            border-radius: 50%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 4;
          }
          .timeline-bar-labels-modern {
            display: flex;
            width: 100%;
            margin-top: 8px;
            justify-content: space-between;
            overflow: visible;
          }
          .timeline-bar-label-group-modern {
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: 150px;
            width: 100%;
            overflow: visible;
            margin-left: -30px;
          }
          .timeline-bar-label-modern {
            font-size: 14px;
            font-weight: 700;
            color: #1a3365;
            text-align: center;
            white-space: nowrap;
          }
          .timeline-bar-sublabel-modern {
            font-size: 12px;
            color: #6c757d;
            margin-top: 4px;
            text-align: center;
            white-space: nowrap;
          }
        `}
      </style>
      <Header />
      <Container className="mt--7" fluid>
        <Card className="shadow">
          <CardHeader className="border-0 d-flex justify-content-end align-items-center">
            <FormGroup className="mb-0 navbar-search ">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  className="search-cls"
                  placeholder="Search..."
                  type="text"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </InputGroup>
            </FormGroup>
            <Button
              color="primary"
              onClick={fetchData}
              size="sm"
              style={btnCss}
              data-toggle="tooltip"
              title="Refresh"
            >
              <i className="fas fa-redo fa-lg" style={iconCss}></i>
            </Button>
          </CardHeader>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Date Requested</th>
                <th scope="col">Transaction Ref</th>
                <th scope="col">Amount</th>
                <th scope="col">Customer Name</th>
                <th scope="col">Customer Phone</th>
                <th scope="col">Reason for Refund</th>
                <th scope="col">Refund Status</th>
                <th scope="col">Timeline</th>
                <th scope="col">Description</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 &&
                filteredData
                  .slice(currentPage * 10, (currentPage + 1) * 10)
                  .map((refund, i) => (
                    <tr key={refund.id}>
                      <td>
                        {refund.createdDate
                          ? moment(refund.createdDate).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )
                          : "-"}
                      </td>
                      <td>{refund.transactionId ?? "-"}</td>
                      <td className="text-right">
                        {refund.amount?.toFixed(2) ?? "0.00"}
                      </td>
                      <td>{refund.customerName ?? "-"}</td>
                      <td>{refund.customerPhoneNumber ?? "-"}</td>
                      <td>
                        {refund.reasonForRefund &&
                        refund.reasonForRefund.length > 100 ? (
                          <span title={refund.reasonForRefund}>
                            {refund.reasonForRefund.substring(0, 100)}...
                          </span>
                        ) : (
                          refund.reasonForRefund ?? "-"
                        )}
                      </td>
                      <td className="text-center">
                        <RefundStatusBadge status={refund.refundStatus} />
                      </td>
                      <td style={{ minWidth: "250px", maxWidth: "350px" }}>
                        <RefundTimeline refund={refund} />
                      </td>
                      <td>{refund.description ?? "-"}</td>
                    </tr>
                  ))}
            </tbody>
            {loading && <FullPageLoader label={"Fetching..."} />}
            {!loading && !filteredData.length && <NoRecordFound />}
          </Table>
          <CardFooter className="py-4">
            {filteredData.length > 0 && (
              <Row>
                <Col lg="6">
                  <div>
                    <small>
                      <strong>Total Records : {filteredData.length}</strong>
                    </small>
                  </div>
                </Col>
                <Col lg="6">
                  <nav aria-label="...">
                    <div className="float-right">
                      <ReactPaginate
                        previousLabel={"prev"}
                        nextLabel={"next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil(filteredData.length / 10)}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={2}
                        onPageChange={handlePageClick}
                        containerClassName={"paginationV2"}
                        subContainerClassName={"pages paginationV2"}
                        activeClassName={"active"}
                        forcePage={currentPage}
                      />
                    </div>
                  </nav>
                </Col>
              </Row>
            )}
          </CardFooter>
        </Card>
      </Container>
    </div>
  );
}

export default RefundList;
